import script from "./layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./layout.vue?vue&type=script&setup=true&lang=ts"

import "./layout.vue?vue&type=style&index=0&id=cdcaaa9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdcaaa9c"]])

export default __exports__